import {
  useState,
  useEffect,
  useContext,
  useRef,
  cloneElement,
  isValidElement,
} from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "./uploadDocumentModal.scss";
import CallIcon from "../../../assets/call filled.svg";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { CaseServices } from "../../../services/CaseServices";
import { CommentServices } from "../../../services/CommentServices";
import RotateRightOutlinedIcon from "@mui/icons-material/RotateRightOutlined";
import Select from "react-select";
import { docUploadRefreshContext } from "../contexts/CaseContexts";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { logOut } from "../../../config/user";
import CrossIcon from "../../../assets/crossIcon.svg";
import MoveIcon from "../../../assets/moveIcon.svg";
import DownloadMultipleDocuments from "./DownloadMultipleDocuments";
import { CircularProgress } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { CaseContext } from "../contexts/CaseContexts";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import PdfIcon from "../../../assets/pdfIcon.png";
import chatIcon from "../../../assets/chat-logo.svg";
import SpeechToText from "../../../assets/speechToText.svg";
import SendIcon from "../../../assets/sendIcon.svg";
import SpeakerIcon from "../../../assets/speakerIcon.svg";
import DeleteIcon from "../../../assets/deleteIcon.svg";
import EditIcon from "../../../assets/editIcon.svg";
import DownIcon from "../../../assets/down-new-arrow.png";
import DownNewIcon from "../../../assets/down-icon.svg";
import UploadDocumentModal from "./uploadDocumentModal";
import { getUser } from "../../../config/user";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocation } from "react-router-dom";
import EditImageFeature from "./EditImageFeature";
import { HospitalServices } from "../../../services/HospitalServices";
import { ControlPointSharp } from "@mui/icons-material";

const isPdfDocumentUrl = (url, extraName = "") => {
  if (!url && !extraName) return false;
  const urlPath = String(url || "")
    .split("?")[0]
    .split("#")[0]
    .toLowerCase();
  const name = String(extraName || "").toLowerCase();
  return urlPath.endsWith(".pdf") || name.endsWith(".pdf");
};

const selectStyle = {
  control: (provided) => ({
    ...provided,
    minHeight: "48px",
    height: "48px",
    width: "154px", // default for 1280px
    borderRadius: "32px",
    padding: "0 16px",
    gap: "15px",
    border: "0.5px solid #017C71",
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
    cursor: "pointer",

    "@media (min-width: 1440px)": {
      width: "190px",
      minHeight: "50px",
      height: "50px",
    },

    "@media (min-width: 1920px)": {
      width: "280px",
      minHeight: "50px",
      height: "50px",
    },

    "&:hover": {
      border: "0.5px solid #017C71",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),

  placeholder: (provided) => ({
    ...provided,
    fontFamily: "Lufga",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "-0.36px",
    textTransform: "capitalize",
    color: "#191919",

    "@media (min-width: 1440px)": {
      fontSize: "14px",
    },

    "@media (min-width: 1920px)": {
      fontSize: "14px",
    },
  }),

  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Lufga",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "-0.36px",
    textTransform: "capitalize",
    color: "#191919",

    "@media (min-width: 1440px)": {
      fontSize: "14px",
    },

    "@media (min-width: 1920px)": {
      fontSize: "14px",
    },
  }),

  menu: (provided) => ({
    ...provided,
    marginTop: 0,
    borderRadius: "0 0 16px 16px",
    overflow: "hidden",
    zIndex: 9999,
  }),

  option: (provided, state) => ({
    ...provided,
    fontFamily: "Lufga",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "-0.36px",
    textTransform: "capitalize",
    backgroundColor: state.isSelected ? "#F5F5F5" : "#FFFFFF",
    color: "#191919",
    cursor: "pointer",

    "@media (min-width: 1440px)": {
      fontSize: "14px",
    },

    "@media (min-width: 1920px)": {
      fontSize: "14px",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  dropdownIndicator: () => ({
    display: "none",
  }),
};

const doctorSelectStyle = {
  control: (provided) => ({
    ...provided,
    minHeight: "48px",
    height: "48px",
    width: "146px", // 1280px
    borderRadius: "32px",
    padding: "0 16px",
    gap: "8px",
    border: "0.5px solid #017C71",
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
    cursor: "pointer",

    "@media (min-width: 1440px)": {
      width: "160px",
      minHeight: "50px",
      height: "50px",
      gap: "10px",
    },

    "@media (min-width: 1920px)": {
      width: "180px",
      minHeight: "50px",
      height: "50px",
      gap: "10px",
    },

    "&:hover": {
      border: "0.5px solid #017C71",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),

  placeholder: (provided) => ({
    ...provided,
    fontFamily: "Lufga",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "-0.36px",
    textTransform: "capitalize",
    color: "#191919",

    "@media (min-width: 1440px)": {
      fontSize: "14px",
    },

    "@media (min-width: 1920px)": {
      fontSize: "14px",
    },
  }),

  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Lufga",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "-0.36px",
    textTransform: "capitalize",
    color: "#191919",

    "@media (min-width: 1440px)": {
      fontSize: "14px",
    },

    "@media (min-width: 1920px)": {
      fontSize: "14px",
    },
  }),

  menu: (provided) => ({
    ...provided,
    marginTop: 0,
    borderRadius: "0 0 16px 16px",
    overflow: "hidden",
    zIndex: 9999,
  }),

  option: (provided, state) => ({
    ...provided,
    fontFamily: "Lufga",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "-0.36px",
    textTransform: "capitalize",
    backgroundColor: state.isSelected ? "#F5F5F5" : "#FFFFFF",
    color: "#191919",
    cursor: "pointer",

    "@media (min-width: 1440px)": {
      fontSize: "14px",
    },

    "@media (min-width: 1920px)": {
      fontSize: "14px",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  dropdownIndicator: () => ({
    display: "none",
  }),
};

export default function ReviewDocumentModel({
  documentDetails,
  type,
  trigger,
  embedMode = false,
  onEmbedClose,
  showTrigger = true,
  showUpload = true,
  showDownloadMultiple = true,
  showPatientInfo = true,
  showHeader = true,
  showArrows = true,
  latestStageDocuments,
  setSelectedDocument,
  handleMapDocument,
  queryView = false,
  isReferenceSelected,
  // --- Multi-document review session props (all optional) ---
  initialOpen = false, // open immediately on mount (parent controls mounting)
  onNext, // go to the next document of the review session
  hasNext = false, // whether a next document exists
  onPrev, // go to the previous document of the review session
  hasPrev = false, // whether a previous document exists
  reviewIndex, // 0-based position of this document in the session
  reviewTotal, // total documents in the session
  onActionComplete, // called after a whole-document approve/reject succeeds
  onClose, // called when the user closes the modal
}) {
  const [docDetails, setDocDetails] = useState([]);
  const [open, setOpen] = useState(initialOpen);
  // Status of the whole-document action taken from this modal (session mode)
  const [wholeDocActioned, setWholeDocActioned] = useState(null);
  const [openMultipleDownloads, setOpenMultipleDownloads] = useState(false);
  const refreshFunction = useContext(docUploadRefreshContext);
  const [rejectionReason, setRejectionReason] = useState();
  const [editImage, setEditImage] = useState(false);
  const [rejectCompleteDocument, setRejectCompleteDocument] = useState(false);
  const [selectedImg, setSelectedImg] = useState({
    idx: 0,

    ...(documentDetails?.documenturlmasters?.length > 0
      ? documentDetails?.documenturlmasters[0]
      : ""),
  });
  const [selectedImages, setSelectedImages] = useState([]);
  const [users, setUsers] = useState(null);
  const [message, setMessage] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);
  const [readyForRpaSubmission, setReadyForRpaSubmission] = useState(false);
  const [approveRejectionModal, setApproveRejectionModal] = useState(false);
  const [enlargeImage, setEnlargeImage] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [currentCommentId, setCurrentCommentId] = useState(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(-1);
  const [isListening, setIsListening] = useState(false);
  const [move, setMove] = useState(false);
  const [procedureList, setProcedureList] = useState([
    {
      procedureId: "MG072D",
      specialityId: "MG",
      procedureName: "Chronic Haemodialysis",
    },
    {
      procedureId: "MG072C",
      specialityId: "MG",
      procedureName: "Acute Haemodialysis",
    },
  ]);
  const [doctorList, setDoctorList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [tempDoctor, setTempDoctor] = useState(null);
  const [showDoctorPopup, setShowDoctorPopup] = useState(false);

  const [selectedProcedure, setSelectedProcedure] = useState(null);

  const [showProcedurePopup, setShowProcedurePopup] = useState(false);
  const [tempProcedure, setTempProcedure] = useState(null);
  const [openChatBox, setOpenChatBox] = useState(false);
  const location = useLocation();
  const caseContext = useContext(CaseContext);
  const {
    roleName,
    tmsVersion,
    patientDetails,
    registrationId,
    caseDetails,
    getCaseDetails,
  } = location.pathname?.includes("EditCases") ? caseContext : {};
  const [selectedNewProc, setSelectedNewProc] = useState(
    caseDetails?.caseprocedures[0]?.procedureId,
  );

  const imageRefs = useRef([]);
  const endOfMessagesRef = useRef(null);
  const chatBodyRef = useRef(null);
  const user = getUser();

  const handleOpen = () => setOpen(true);
  const handleClose = async () => {
    setOpen(false);
    onClose?.();
    await refreshFunction?.getMappedDocuments();
    if (embedMode) {
      onEmbedClose?.();
    }

    await getCaseDetails();
  };
  const handleRotate = () => {
    setRotationAngle((prev) => (prev + 90) % 360);
  };
  const handlePrevClick = () => {
    if (selectedImg.idx > 0) {
      setSelectedImg({
        idx: selectedImg.idx - 1,
        documentUrl:
          documentDetails?.documenturlmasters[selectedImg.idx - 1]?.documentUrl,
      });

      // setRotationAngle(0);
    }
  };
  const handleNextClick = () => {
    const docs = docDetails?.documenturlmasters || [];

    if (selectedImg.idx < docs.length - 1) {
      setSelectedImg({
        idx: selectedImg.idx + 1,
        ...docs[selectedImg.idx + 1],
      });
    }
  };
  // CaseContext may be absent when this modal is opened outside the case page (e.g. Manage Query → TmsQueries).
  // const { roleName, tmsVersion, patientDetails, registrationId } =
  //   useContext(CaseContext) ?? {};

  const ApproveDocument = async (docId) => {
    setSubmitting(true);

    try {
      const images = docDetails?.documenturlmasters || [];

      const hasReady = images.some((doc) => doc?.status === "READYFORRPA");

      // ✅ NEW LOGIC
      if (!hasReady && images.length > 0) {
        const currentImage = images[selectedImg.idx] || images[0];

        // Auto mark one image
        await CaseServices.updateDocumentStatus(
          docId,
          {
            rpaImages: [
              {
                id: currentImage.id,
                status: "READYFORRPA",
              },
            ],
          },
          roleName,
        );
      }

      // ✅ Now approve anyway
      await CaseServices.updateDocumentStatus(
        docId,
        { status: "APPROVED" },
        roleName,
      );

      window.alert("Status approved");

      if (onActionComplete) {
        // Review-session mode: stay on this document, let the user press Next
        setWholeDocActioned("APPROVED");
        const noDocsLeft = await onActionComplete(docId, "APPROVED");
        // Nothing left to review in this session: close automatically
        if (noDocsLeft) await handleClose();
      } else {
        handleClose();
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }

    setSubmitting(false);
  };
  const handleMove = () => {
    setMove(!move);
  };
  const handleUpdateDoctor = async () => {
    try {
      if (!tempDoctor?.id) {
        return window.alert("Invalid doctor selected");
      }

      const payload = {
        caseId: documentDetails?.caseId,
        doctorId: tempDoctor?.id,
      };

      const res = await CaseServices.addDoctorProcedureMapping(payload);

      // window.alert("Doctor updated successfully");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleConfirmDoctorChange = async () => {
    try {
      setSelectedDoctor(tempDoctor);

      await handleUpdateDoctor();

      // await getCaseDetails();

      setShowDoctorPopup(false);

      // await refreshFunction?.getMappedDocuments();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleCancelDoctorChange = () => {
    setTempDoctor(null);
    setShowDoctorPopup(false);
  };

  const getDate = (dateString) => {
    const date = new Date(dateString);

    // Format the date as DD/MM/YYYY HH:MM
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  const handleReadyToSubmissionCheck = async (docId) => {
    setReadyForRpaSubmission(true);
    try {
      await CaseServices.updateDocumentStatus(
        docId,
        {
          rpaImages: [
            {
              id: docDetails?.documenturlmasters[selectedImg.idx].id,
              status: "READYFORRPA",
            },
          ],
        },
        roleName,
      );
      docDetails.documenturlmasters[selectedImg.idx].status =
        docDetails.documenturlmasters[selectedImg.idx].status === "READYFORRPA"
          ? "UPLOADED"
          : "READYFORRPA";
      setDocDetails({ ...docDetails });
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setReadyForRpaSubmission(false);
  };
  const handleConfirmProcedureChange = async () => {
    try {
      await handleUpdateProcedure();

      setSelectedNewProc(tempProcedure?.procedureId); // ✅ then update UI

      //await getCaseDetails(); // ✅ fresh data

      setShowProcedurePopup(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCancelProcedureChange = () => {
    setTempProcedure(null); // discard temp
    setShowProcedurePopup(false);
  };
  const handleDeleteImage = async () => {
    const images = docDetails?.documenturlmasters || [];
    const imgId = images[selectedImg.idx]?.id;

    // 🔥 RULE: If status is INREVIEW and only 1 image exists → block delete
    if (
      (docDetails?.status === "INREVIEW" ||
        docDetails?.status === "APPROVED" ||
        docDetails?.status === "REJECTED") &&
      images.length <= 1
    ) {
      window.alert(
        "You cannot delete the last image while the document is under review.",
      );
      return;
    }

    try {
      const res = await CaseServices.deleteDocumentImage(imgId);
      window.alert(res?.data?.message);
      await refreshFunction?.getMappedDocuments();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const showFilters =
    caseDetails?.caseSubType === "DIALYSIS" &&
    caseDetails?.caseType === "DAYCARE";

  const RejectDocument = async (docId, data) => {
    setSubmitting(true);
    let noDocsLeft = false;
    try {
      if (!rejectCompleteDocument) {
        await CaseServices.updateDocumentStatus(
          docId,
          {
            status: "REJECTED",
            rejectedUrlIds: [
              {
                id: docDetails?.documenturlmasters[selectedImg.idx].id,
                rejectionReason: rejectionReason,
              },
            ],
          },
          roleName,
        );
        window.alert("Document Rejected");
        docDetails.documenturlmasters[selectedImg.idx].status = "REJECTED";
        setDocDetails({ ...docDetails });
      } else {
        await CaseServices.updateDocumentStatus(
          docId,
          {
            status: "REJECTED",
            rejectionReason: rejectionReason,
            completeDocRejected: rejectCompleteDocument,
          },
          roleName,
        );
        window.alert("Document Rejected");
        if (onActionComplete) {
          // Review-session mode: stay on this document, let the user press Next
          setWholeDocActioned("REJECTED");
          noDocsLeft = await onActionComplete(docId, "REJECTED");
        } else {
          await refreshFunction?.getMappedDocuments();
        }
        setRejectCompleteDocument(false);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setRejectionReason("");
    setSubmitting(false);
    // Nothing left to review in this session: close automatically
    if (noDocsLeft) await handleClose();
  };

  const handleUpdateProcedure = async () => {
    try {
      const data = { ...tempProcedure, caseId: documentDetails?.caseId };

      const res = await CaseServices.updateCaseProc(data); // ✅ FIX
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleReject = () => {
    if (rejectionReason) {
      RejectDocument(documentDetails.id);
      setApproveRejectionModal(false);
      setOpen(true);
      setEnlargeImage(false);
    } else {
      window.alert("Rejection reason is mandatory");
    }
  };
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  const getUsers = async () => {
    try {
      const res = await CommentServices.getAllUserDetail();
      setUsers(res?.data?.users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getProcedures = async () => {
    try {
      const res = await CommentServices.getCaseTypeProcedureMapping();

      const procedures = res?.data?.data?.map((item) => {
        const procedureName = item?.procedureDetails?.procedure;
        const procedureCode = item?.procedureDetails?.procedureId;

        const shortName = procedureName.split(" ").slice(0, 3).join(" ");

        return `${shortName} - ${procedureCode}`;
      });

      // remove duplicates
      const uniqueProcedures = [...new Set(procedures)];

      // setProcedureList(uniqueProcedures);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getFormattedDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Convert to 12-hour format with AM/PM
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Hour '0' should be '12'

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };
  const getDocComments = async () => {
    try {
      const res = await CommentServices.getDocumentComments(
        type === "CASEDOCUMENT",
        docDetails?.documenturlmasters[selectedImg.idx].id,
      );
      setDocDetails(res?.data?.documentDetails);
      docDetails.documenturlmasters[selectedImg.idx] =
        res?.data?.documentDetails;
      setDocDetails({ ...docDetails });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleCommentAdd = async () => {
    if (message) {
      try {
        const commentData = {
          documentId: docDetails?.documenturlmasters[selectedImg.idx].id,
          message: message,
          commentOn: "CASEDOCUMENT",
        };
        const res = await CommentServices.sendComment(commentData);
        setMessage("");
        // await referenceContext.getMappedDocuments();
        await getDocComments();
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }
  };
  const handleCallButtonClick = async () => {
    const text = `Welcome to Settlemed!
  Thank you for reaching out. Your call request has been received.
  We appreciate your patience—our Command Centre team will get back to you shortly via the Settlemed mobile application.
  
  If you haven’t downloaded the app yet, please do so to stay connected and ensure smooth communication.`;

    try {
      const commentData = {
        documentId: docDetails?.documenturlmasters[selectedImg.idx].id,
        message: "Kindly give me a call back at your earliest convenience",
        commentOn: "CASEDOCUMENT",
      };
      await CommentServices.sendComment(commentData);

      await getDocComments();

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-US";
      utterance.rate = 1.5;

      window.speechSynthesis.speak(utterance);
      window.alert(text);
      window.speechSynthesis.cancel();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const markReadNotification = async () => {
    try {
      docDetails?.documenturlmasters &&
        (await CommentServices.markNotificationReadByDocId(
          docDetails?.documenturlmasters[selectedImg?.idx]?.id,
        ));
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const updateViewDetail = async () => {
    try {
      const res = await CommentServices.updateViewDetail({
        documentId: docDetails?.documenturlmasters[selectedImg.idx].id,
        commentOn: "CASEDOCUMENT",
      });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDoctorList = async () => {
    try {
      const hospitalId = caseDetails?.hospitalId;

      if (!hospitalId) return;

      const response = await HospitalServices.getDoctorList(
        "", // ✅ no specialityId
        1,
        40,
        hospitalId,
      );

      setDoctorList(response?.data?.list || []);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleSpeak = (text, commentId) => {
    if (!window.speechSynthesis) {
      alert("Speech Synthesis not supported in your browser");
      return;
    }

    // Cancel any ongoing speech
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1;

    const words = text.split(/\s+/); // Split by any whitespace
    setCurrentCommentId(commentId);
    setCurrentWordIndex(-1); // Reset word index
    utterance.onboundary = (event) => {
      if (event?.name === "word") {
        const charIndex = event?.charIndex;
        let currentCharCount = 0;

        for (let i = 0; i < words.length; i++) {
          // Add word length plus space (except last word)
          currentCharCount += words[i].length + (i < words.length - 1 ? 1 : 0);

          if (charIndex < currentCharCount) {
            setCurrentWordIndex(i);
            break;
          }
        }
      }
    };

    utterance.onend = () => {
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    utterance.onerror = (event) => {
      console.error("SpeechSynthesis error:", event);
      setCurrentWordIndex(-1);
      setCurrentCommentId(null);
    };

    window.speechSynthesis.speak(utterance);
  };

  // const stopSpeaking = () => {
  //   window.speechSynthesis.cancel();
  //   setCurrentWordIndex(-1);
  //   setCurrentCommentId(null);
  // };
  const textareaRef = useRef(null);
  const LINE_HEIGHT = 20; // px, match your font-size/line-height
  const MAX_LINES = 4;
  const MIN_LINES = 1;

  const adjustTextareaHeight = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto"; // reset first to get correct scrollHeight

    const maxHeight = LINE_HEIGHT * MAX_LINES;
    const minHeight = LINE_HEIGHT * MIN_LINES;

    const newHeight = Math.min(Math.max(el.scrollHeight, minHeight), maxHeight);
    el.style.height = `${newHeight}px`;

    // enable scroll only once content exceeds 4 lines
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [message]);

  useEffect(() => {
    if (caseDetails?.caseprocedures?.length) {
      const existingDoc = caseDetails.caseprocedures[0];

      if (existingDoc?.doctorId || existingDoc?.doctorName) {
        setSelectedDoctor({
          id: existingDoc?.doctorId,
          fullName: existingDoc?.doctorName,
        });
      }
    }
  }, [caseDetails]);
  useEffect(() => {
    markReadNotification();
    const handleKeyDown = (event) => {
      if (
        document.activeElement.tagName === "INPUT" ||
        document.activeElement.tagName === "TEXTAREA"
      ) {
        return;
      }

      if (event.key === "ArrowRight") {
        handleNextClick();
      }

      if (event.key === "ArrowLeft") {
        handlePrevClick();
      }
    };

    window.addEventListener("resize", updateDimensions);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", updateDimensions);
      window.speechSynthesis.cancel();
    };
  }, [selectedImg.idx, docDetails?.documenturlmasters?.length]);
  useEffect(() => {
    documentDetails.documenturlmasters = documentDetails.documenturlmasters.map(
      (doc) => {
        return { ...doc, selected: false };
      },
    );

    setDocDetails({ ...documentDetails });
    markReadNotification();
    getProcedures();
    getUsers();
  }, []);
  useEffect(() => {
    if (selectedImg.idx !== null && imageRefs.current[selectedImg.idx]) {
      imageRefs.current[selectedImg.idx].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
      updateViewDetail();
    }
  }, [selectedImg]);
  imageRefs.current = [];

  useEffect(() => {
    if (embedMode && documentDetails) {
      setOpen(true);
    }
  }, [embedMode, documentDetails?.id]);

  useEffect(() => {
    if (openChatBox && endOfMessagesRef.current) {
      setTimeout(() => {
        endOfMessagesRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }, 100);
    }
  }, [
    openChatBox,
    message,
    docDetails?.documenturlmasters?.[selectedImg.idx]?.comments?.length,
  ]);

  const boxSx = embedMode
    ? {
        position: "relative",
        top: 0,
        left: 0,
        transform: "none",
        width: "100%",
        height: "100%",
        maxHeight: "100%",
        minHeight: 0,
        borderRadius: "12px",
        bgcolor: "background.paper",
        border: "none",
        boxShadow: "none",
        p: 2,
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
      }
    : {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: width > 1550 ? "80%" : width > 640 ? "90%" : "328px",
        height: "98%",
        borderRadius: "16px",
        bgcolor: "background.paper",
        border: "none",
        boxShadow: 24,
        p: 4,
      };

  console.log("caseDetails", caseDetails);

  return (
    <div
      className={`upload-modal-container ${
        embedMode ? "relative h-full w-full min-h-0 flex flex-col" : ""
      }`}
    >
      {!embedMode &&
        showTrigger &&
        (trigger && isValidElement(trigger) ? (
          cloneElement(trigger, {
            onClick: (e) => {
              trigger.props.onClick?.(e);
              handleOpen();
            },
            style: { cursor: "pointer", ...(trigger.props.style || {}) },
            role: trigger.props.role ?? "button",
            tabIndex: trigger.props.tabIndex ?? 0,
          })
        ) : (
          <button type="button" className="upload-btn" onClick={handleOpen}>
            {type === "review" ? "REVIEW" : "VIEW"}
          </button>
        ))}
      <Modal
        open={embedMode ? true : open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="custom-modal"
        disablePortal={embedMode}
        hideBackdrop={embedMode}
        disableEnforceFocus={embedMode}
        disableAutoFocus={embedMode}
        disableRestoreFocus={embedMode}
        sx={{
          zIndex: embedMode ? 2 : "1205",
          ...(embedMode
            ? {
                position: "absolute",
                inset: 0,
              }
            : {}),
        }}
      >
        <Box sx={boxSx}>
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              fontFamily: "Inter, sans-serif",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "100%",
              width: "100%",
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            {!embedMode && showHeader && (
              <>
                <div
                  style={{
                    fontFamily: "inherit",
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#191919",
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "16px",
                  }}
                  className="w-[95%]"
                >
                  <span>Review: {documentDetails?.documentName}</span>
                  {wholeDocActioned && (
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        padding: "4px 12px",
                        borderRadius: "32px",
                        color: "white",
                        backgroundColor:
                          wholeDocActioned === "APPROVED"
                            ? "#017C57"
                            : "#FF4343",
                      }}
                    >
                      {wholeDocActioned}
                    </span>
                  )}
                  {onNext && reviewTotal > 1 && (
                    <>
                      {onPrev && (
                        <button
                          type="button"
                          disabled={!hasPrev || isSubmitting}
                          onClick={onPrev}
                          style={{
                            borderRadius: "32px",
                            fontFamily: "Inter, sans-serif",
                            fontWeight: "600",
                            fontSize: "12px",
                            color: hasPrev ? "#017C57" : "#797979",
                            border: `1px solid ${hasPrev ? "#017C57" : "#E4E4E4"}`,
                            backgroundColor: "white",
                            cursor:
                              hasPrev && !isSubmitting
                                ? "pointer"
                                : "not-allowed",
                            opacity: hasPrev && !isSubmitting ? 1 : 0.6,
                          }}
                          className="h-[34px] px-6"
                        >
                          &larr; PREV DOCUMENT
                        </button>
                      )}
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "#797979",
                        }}
                      >
                        {reviewIndex + 1} of {reviewTotal}
                      </span>
                      <button
                        type="button"
                        disabled={!hasNext || isSubmitting}
                        onClick={onNext}
                        style={{
                          borderRadius: "32px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: "600",
                          fontSize: "12px",
                          color: hasNext ? "#017C57" : "#797979",
                          border: `1px solid ${hasNext ? "#017C57" : "#E4E4E4"}`,
                          backgroundColor: "white",
                          cursor:
                            hasNext && !isSubmitting
                              ? "pointer"
                              : "not-allowed",
                          opacity: hasNext && !isSubmitting ? 1 : 0.6,
                        }}
                        className="h-[34px] px-6"
                      >
                        NEXT DOCUMENT &rarr;
                      </button>
                    </>
                  )}
                </div>

                {!queryView && (
                  <div
                    style={{
                      fontFamily: "inherit",
                      fontSize: "16px",
                      fontWeight: "400",
                      color: "#797979",
                      marginTop: "16px",
                    }}
                  >
                    {documentDetails?.description}
                  </div>
                )}
              </>
            )}

            {!queryView && (
              <div className=" flex gap-2 justify-between  w-[95%] mb-2 ">
                {type === "review" && !embedMode && !wholeDocActioned && (
                  <div className="flex gap-2">
                    <div>
                      <button
                        style={{
                          borderRadius: "32px",
                          fontFamily: "Inter, sans-serif",
                          textAlign: "center",
                          fontWeight: "600",
                          fontSize: "12px",
                          backgroundColor: "#FF4343",
                          color: "white",
                          border: "1px solid #FF4343",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        // onClick={() => RejectDocument(documentDetails.id)}
                        className="h-[34px] px-8 py-3"
                        onClick={() => {
                          setApproveRejectionModal(true);
                          setRejectCompleteDocument(true);
                          setOpen(false);
                        }}
                      >
                        <CancelOutlinedIcon sx={{ height: "18px" }} /> REJECT
                        WHOLE DOCUMENT
                      </button>
                    </div>
                    <button
                      style={{
                        borderRadius: "32px",

                        fontFamily: "Inter, sans-serif",
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "12px",
                        backgroundColor: "#017C57",
                        color: "white",
                        border: "1px solid #017C57",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="h-[34px] w-[120px] xl:w-[250px] cursor-pointer"
                      onClick={() => ApproveDocument(documentDetails.id)}
                    >
                      <CheckCircleOutlinedIcon sx={{ height: "18px" }} />{" "}
                      APPROVE WHOLE DOCUMENT
                    </button>
                  </div>
                )}

                <div className="flex gap-2 items-center ml-auto">
                  {showUpload && !embedMode && (
                    <UploadDocumentModal
                      documentDetails={documentDetails}
                      sequencePrev={docDetails?.documenturlmasters?.length}
                    />
                  )}

                  {showDownloadMultiple && !embedMode && (
                    <div
                      onClick={() => setOpenMultipleDownloads(true)}
                      style={{ border: "1px solid #E4E4E4" }}
                      className="flex items-center gap-2 text-[11px] xl:text-xs text-[#017C57] font-semibold py-1 px-3 xl:py-2 xl:px-4 tracking-wider rounded-full cursor-pointer"
                    >
                      <FileDownloadOutlinedIcon
                        className="text-[#017C57]"
                        sx={{ fontSize: "16px" }}
                      />
                      DOWNLOAD MULTIPLE
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* <div className="relative flex-1  w-full h-full overflow-y-auto overflow-x-hidden pr-2 bg-green-400"> */}
            <div
              className="relative w-full overflow-visible "
              style={{
                height: "calc(100vh - 250px)",
                minHeight: 0,
                flexShrink: 0,
              }}
            >
              {" "}
              <div
                style={{
                  fontFamily: "inherit",
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#797979",
                  marginTop: "12px",
                  // display: "flex",
                  // justifyContent: "center",
                }}
              >
                <div className="relative  w-full ">
                  {" "}
                  <div className="absolute top-1 right-8 flex items-center gap-4 cursor-pointer z-20">
                    <a
                      href={selectedImg.documentUrl}
                      target="_blank"
                      download
                      className="flex gap-1 items-center no-underline"
                    >
                      <FileDownloadOutlinedIcon
                        className="text-[#017C57]"
                        sx={{ fontSize: 20 }}
                      />{" "}
                    </a>

                    {!embedMode && (
                      <img
                        src={DeleteIcon}
                        alt="delete-icon"
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to remove this image",
                            )
                          ) {
                            handleDeleteImage();
                          }
                        }}
                      />
                    )}
                  </div>
                  <div className="h-full w-full  py-2 rounded-[8px]  flex justify-center items-start">
                    {" "}
                    <div className="h-full w-full ">
                      {/* IMAGE + MOVE WRAPPER */}
                      <div
                        className="relative w-full flex justify-center items-start min-h-0"
                        style={{
                          height: "calc(100vh - 360px)",
                        }}
                      >
                        {" "}
                        {/* SCROLLABLE IMAGE CONTAINER */}
                        <div
                          className="w-full overflow-y-auto overflow-x-hidden py-2 rounded-[8px]  flex justify-center items-start"
                          style={{
                            height: "100%",
                          }}
                        >
                          {" "}
                          {isPdfDocumentUrl(
                            selectedImg?.documentUrl,
                            selectedImg?.description,
                          ) ? (
                            <iframe
                              key={selectedImg?.documentUrl}
                              src={`${selectedImg.documentUrl}#toolbar=1&navpanes=0&scrollbar=1&view=FitH`}
                              title={selectedImg?.description || "document-pdf"}
                              className="rounded-[8px] border-0 bg-white"
                              style={{
                                width: "100%",
                                height: "100%",
                                minHeight: "100%",
                              }}
                            />
                          ) : (
                            <img
                              src={selectedImg.documentUrl}
                              className="rounded-[8px] w-[75%] object-contain cursor-zoom-in"
                              style={{
                                height: "auto",
                                minHeight: "135%",
                              }}
                              onClick={() => {
                                setEnlargeImage(selectedImg.documentUrl);
                                setOpen(false);
                              }}
                            />
                          )}
                          {/* DELETE ICON */}
                        </div>
                        {/* FIXED MOVE BUTTON */}
                        {move ? (
                          <div className="absolute xl:top-[40%] 2xl:top-[42%] 3xl:top-[50%]  left-1/2 -translate-x-1/2 z-40">
                            <div className="flex items-center gap-[14px] bg-white border-[0.75px] border-solid border-[#E8E8E8] py-3 2xl:p-4 px-4 rounded-full shadow-md">
                              <Select
                                placeholder="Document Name"
                                options={latestStageDocuments}
                                getOptionLabel={(options) =>
                                  options["documentName"]
                                }
                                getOptionValue={(options) => options["id"]}
                                onChange={(item) => setSelectedDocument(item)}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    width: "300px",
                                    borderColor: "#017C57",
                                    borderRadius: 999,
                                    boxShadow: state.isFocused
                                      ? "0 0 0 1px #017C57"
                                      : "none",
                                    "&:hover": {
                                      borderColor: "#017C57",
                                    },
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: "#017C57",
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color: "#017C57",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color: "#017C57",
                                  }),
                                  dropdownIndicator: (base) => ({
                                    ...base,
                                    color: "#017C57",
                                    "&:hover": {
                                      color: "#017C57",
                                    },
                                  }),
                                  indicatorSeparator: () => ({
                                    display: "none",
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />

                              <div
                                className="text-white bg-[#017C57] border border-solid border-[#017C57] px-[25px] py-[11.5px] rounded-full cursor-pointer"
                                onClick={() =>
                                  handleMapDocument(
                                    selectedImg,
                                    setSelectedImg,
                                    docDetails,
                                    setDocDetails,
                                  )
                                }
                              >
                                SAVE
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={`
  absolute top-[55%] 3xl:top-[65%] left-1/2 -translate-x-1/2 z-20
  ${embedMode ? "flex" : "hidden"} items-center gap-[14px]
  backdrop-blur-[2.5px] saturate-150
  bg-[#017C574D]
  shadow-[0_4px_12px_rgba(0,0,0,0.12),inset_0_1px_0_rgba(255,255,255,0.6)]
  rounded-full py-3 px-4 2xl:px-5
  text-sm text-black font-medium
  active:scale-95
  transition-all duration-200
  cursor-pointer
`}
                            onClick={handleMove}
                          >
                            <span className="font-[Lufga] font-medium text-[12px] leading-[100%] tracking-[-0.37px]">
                              MOVE
                            </span>

                            <img
                              src={MoveIcon}
                              alt="move-icon"
                              className="w-[18px] h-[18px] object-contain"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                queryView ? "w-full mt-4" : "w-[95%] flex justify-between"
              }`}
            >
              {/* Image List */}
              <div
                className={`absolute bottom-4 left-4 z-30 ${
                  queryView
                    ? "right-[110px]"
                    : "w-[42%] xl:w-[48%] 2xl:w-[55%] 3xl:w-[60%]"
                }`}
              >
                {" "}
                <div
                  className="flex items-center gap-[10px] overflow-x-auto overflow-y-hidden scroll-smooth pb-1 w-full"
                  onWheel={(e) => {
                    e.currentTarget.scrollLeft += e.deltaY;
                  }}
                >
                  {" "}
                  {docDetails?.documenturlmasters?.map((document, idx) => {
                    return (
                      <div
                        key={idx}
                        ref={(el) => (imageRefs.current[idx] = el)}
                        style={{
                          border:
                            selectedImg.idx === idx
                              ? "2px solid #017C57"
                              : document?.status === "REJECTED"
                                ? "2px solid #FF4343"
                                : "1px solid #E4E4E4",
                          boxShadow:
                            selectedImg.idx === idx
                              ? "0 4px 12px rgba(0,0,0,0.18)"
                              : "none",
                        }}
                        className="
relative
min-w-[92px]
w-[90px]
h-[54px]
rounded-[12px]
bg-white
p-[4px]
cursor-pointer
transition-all
duration-200
flex
justify-center
items-center
"
                        onClick={() => {
                          setSelectedImg({
                            idx: idx,
                            ...document,
                          });
                        }}
                      >
                        {/* CHECKBOX */}
                        {queryView && (
                          <div className="absolute top-1 left-1 z-20">
                            <input
                              type="checkbox"
                              className="w-[18px] h-[18px] rounded-full accent-[#017C57] cursor-pointer "
                              checked={document?.selected}
                              onChange={() => {
                                const temp = docDetails;
                                temp.documenturlmasters[idx].selected =
                                  !temp.documenturlmasters[idx].selected;

                                setDocDetails(temp);
                              }}
                            />
                          </div>
                        )}

                        {/* PDF thumbnail */}
                        {isPdfDocumentUrl(
                          document?.documentUrl,
                          document?.description,
                        ) ? (
                          <img
                            src={PdfIcon}
                            alt="pdf-icon"
                            className="w-full h-full object-contain rounded-[8px]"
                          />
                        ) : (
                          <img
                            src={document.documentUrl}
                            alt="uploaded-image"
                            className="w-full h-full object-cover rounded-[8px]"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* Actions To Be Performed on the selectedd image */}

              {!queryView && (
                <div
                  style={{ border: "1px solid #d5d5d5" }}
                  className="absolute bottom-4 right-[66px] z-30 w-fit flex gap-2 justify-center items-center bg-white p-2 rounded-[16px] shadow-md"
                >
                  <div
                    className="flex items-center gap-1 cursor-pointer "
                    onClick={() => handleReadyToSubmissionCheck(docDetails?.id)}
                  >
                    {readyForRpaSubmission ? (
                      <CircularProgress />
                    ) : (
                      <>
                        <input
                          type="checkbox"
                          checked={
                            docDetails?.documenturlmasters &&
                            docDetails?.documenturlmasters[
                              selectedImg.idx
                            ]?.status
                              ?.toLowerCase()
                              ?.includes("readyforrpa")
                          }
                          className="h-[20px] w-[20px]"
                        />
                        <div className="text-nowrap">Ready to Submission</div>
                      </>
                    )}
                  </div>

                  {isSubmitting ? (
                    <div>
                      <CircularProgress />{" "}
                    </div>
                  ) : (
                    type === "review" &&
                    caseDetails?.isTpa !== true && (
                      <div>
                        <button
                          style={{
                            borderRadius: "32px",
                            fontFamily: "Inter, sans-serif",
                            textAlign: "center",
                            fontWeight: "600",
                            fontSize: "12px",
                            backgroundColor: "#FF4343",
                            color: "white",
                            border: "1px solid #FF4343",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          // onClick={() => RejectDocument(documentDetails.id)}
                          className="h-[34px] w-[120px] xl:w-[160px] "
                          onClick={() => {
                            setApproveRejectionModal(true);
                            setOpen(false);
                          }}
                        >
                          <CancelOutlinedIcon sx={{ height: "18px" }} /> REJECT
                        </button>
                      </div>
                    )
                  )}
                  <div
                    style={{ border: "1px solid #E4E4E4" }}
                    className="flex justify-center items-center  bg-white rounded-full p-2"
                  >
                    <a
                      href={selectedImg.documentUrl}
                      download
                      className="flex gap-1 items-center no-underline"
                    >
                      <FileDownloadOutlinedIcon
                        className="text-[#017C57]"
                        sx={{ fontSize: "18px" }}
                      />{" "}
                      <div
                        style={{ display: width > 1780 ? "block" : "none" }}
                        className=" text-[#017c57] text-sm fonr-semibold"
                      >
                        Download
                      </div>
                    </a>
                  </div>
                </div>
              )}
            </div>
            {!embedMode && showPatientInfo && (
              <div className="absolute top-[15%] left-0">
                <Tooltip
                  title={
                    <div className="text-sm leading-5">
                      <div>
                        <b>Beneficiary No:</b> {patientDetails?.beneficiaryNo}
                      </div>
                      <div>
                        <b>Patient Name:</b> {patientDetails?.patientName}
                      </div>
                      <div>
                        <b>Registration ID:</b> {registrationId}
                      </div>
                      <div>
                        <b>Gender:</b> {patientDetails?.gender}
                      </div>
                      <div>
                        <b>Age:</b> {patientDetails?.age}
                      </div>
                      <div>
                        <b>Registered Date:</b>{" "}
                        {getDate(patientDetails?.registeredDate)}
                      </div>
                    </div>
                  }
                  arrow
                  placement="right"
                >
                  <div className="flex gap-2 items-center">
                    <div> Patient Info</div>
                    <InfoOutlinedIcon
                      className="cursor-pointer text-[#017c52]"
                      sx={{ fontSize: 20 }}
                    />
                  </div>
                </Tooltip>
              </div>
            )}

            {showArrows && (
              <>
                <div
                  className="absolute top-1/2 -translate-y-1/2 left-2 z-20 cursor-pointer"
                  onClick={handlePrevClick}
                >
                  <ArrowBackOutlinedIcon style={{ fontSize: 60 }} />
                </div>

                <div
                  className="absolute top-1/2 -translate-y-1/2 right-2 z-20 cursor-pointer"
                  onClick={handleNextClick}
                >
                  <ArrowBackOutlinedIcon
                    style={{ fontSize: 60 }}
                    className="rotate-180"
                  />
                </div>
              </>
            )}
            {/* CHAT PANEL */}
            {openChatBox && (
              <>
                {/* BLUR BACKGROUND */}
                {/* <div className="absolute inset-0   bg-[#00000008]" />{" "} */}
                {/* CHAT BOX */}
                <div className="absolute bottom-16 right-2 z-[45]">
                  {" "}
                  <div
                    style={{
                      border: "0.85px solid #F0F0F0",
                      boxSizing: "border-box",
                    }}
                    className="w-[511px] xl:w-[320px] 2xl:w-[380px] 3xl:w-[511px]  xl:h-[360px] 2xl:h-[360px] 3xl:h-[476px] rounded-[25.46px] shadow-2xl px-[8px] pt-[8px] pb-[6px] flex flex-col backdrop-blur-[4px] bg-[#FFFFFFE6]"
                  >
                    {/* FILTERS */}
                    {showFilters && (
                      <div className="flex gap-[5.99px] items-center px-2 pb-3">
                        {/* Procedure */}
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal text-[#191919] mb-1">
                            Procedure
                          </label>

                          <div className="relative">
                            <Select
                              options={procedureList}
                              getOptionLabel={(option) =>
                                `${option.procedureName} - ${option.procedureId}`
                              }
                              getOptionValue={(option) => option.procedureId}
                              styles={selectStyle}
                              components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                              }}
                              onChange={(item) => {
                                if (item?.procedureId === selectedNewProc) {
                                  window.alert(
                                    "This procedure is already selected",
                                  );
                                  return;
                                }

                                setTempProcedure(item);
                                setShowProcedurePopup(true);
                                setSelectedNewProc(item?.procedureId);
                              }}
                              value={procedureList?.find(
                                (item) => item?.procedureId === selectedNewProc,
                              )}
                            />

                            <img
                              src={DownNewIcon}
                              alt="dropdown-icon"
                              className="absolute right-[19.96px] top-1/2 -translate-y-1/2 w-[16.31px] h-[10.09px] rounded-[2px] pointer-events-none"
                            />
                          </div>
                        </div>

                        {/* Doctor */}
                        <div className="flex flex-col">
                          <label className="text-[14px] font-normal text-[#191919] mb-1">
                            Doctor Name
                          </label>

                          <div className="relative w-[180px] xl:w-[160px] lg:w-[140px]">
                            <Select
                              options={doctorList}
                              getOptionLabel={(option) => option.fullName}
                              getOptionValue={(option) => option.id}
                              styles={doctorSelectStyle}
                              components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                              }}
                              onMenuOpen={() => {
                                if (!doctorList.length) getDoctorList();
                              }}
                              onChange={(item) => {
                                if (item?.id === selectedDoctor?.id) {
                                  window.alert(
                                    "This doctor is already selected",
                                  );
                                  return;
                                }

                                setTempDoctor(item);
                                setShowDoctorPopup(true);
                              }}
                              value={
                                doctorList?.find(
                                  (doc) => doc?.id === selectedDoctor?.id,
                                ) || selectedDoctor
                              }
                              placeholder="Select Doctor"
                            />

                            <img
                              src={DownNewIcon}
                              alt="dropdown-icon"
                              className="absolute right-[17.96px] top-1/2 -translate-y-1/2 w-[16.31px] h-[10.09px] rounded-[2px] pointer-events-none"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {/* HEADER */}
                    <div
                      style={{ boxSizing: "border-box" }}
                      className="w-full bg-white flex justify-between items-center px-[10px] py-[16px] rounded-t-[30px] flex-shrink-0 border-b border-[#F0F0F0]"
                    >
                      <div className="text-[24px] text-[#191919] font-medium">
                        Chat box (
                        {docDetails &&
                          docDetails?.documenturlmasters &&
                          (docDetails?.documenturlmasters[selectedImg.idx]
                            ?.comments?.length ||
                            0)}
                        )
                      </div>

                      <div className="flex items-center gap-[16px] mr-2">
                        <img
                          src={CallIcon}
                          alt="call-icon"
                          className="cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCallButtonClick();
                          }}
                        />
                        <div
                          className="text-[32px] leading-none cursor-pointer text-[#191919]"
                          onClick={() => setOpenChatBox(false)}
                        >
                          ×
                        </div>
                      </div>
                    </div>

                    {/* CHAT BODY */}
                    <div
                      ref={chatBodyRef}
                      className="flex-1 min-h-0 w-full overflow-y-auto overflow-x-hidden pr-2 pt-2 scroll-smooth"
                    >
                      {" "}
                      {docDetails &&
                        docDetails?.documenturlmasters &&
                        docDetails?.documenturlmasters[
                          selectedImg.idx
                        ]?.comments?.map((comment, idx) => {
                          return (
                            <div key={idx}>
                              {user?.user?.id === comment?.from ? (
                                <div
                                  key={idx}
                                  className="flex justify-end mt-[10px]"
                                >
                                  <div className="max-w-[75%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#dcf8c6] rounded-[20px]">
                                    <div className="flex items-center justify-between">
                                      <div className="flex flex-row-reverse items-center gap-[10px]">
                                        <div className="w-[33px] h-[33px] flex justify-center items-center text-[#0B0B0B] text-[20px] bg-white rounded-full">
                                          U
                                        </div>

                                        <div className="text-[15px] font-medium">
                                          You
                                        </div>
                                      </div>

                                      <div className="flex items-center gap-[20px] px-[10px]">
                                        <div className="text-[10px] text-[#969696]">
                                          {getFormattedDate(comment.createdAt)}

                                          <DoneAllOutlinedIcon
                                            style={{
                                              color:
                                                comment?.views?.length >=
                                                comment?.to?.length
                                                  ? "#00ccff"
                                                  : "",
                                              fontSize: "14px",
                                              marginLeft: "8px",
                                            }}
                                          />
                                        </div>

                                        <div>
                                          <img
                                            src={SpeakerIcon}
                                            alt="speaker-icon"
                                            className="cursor-pointer w-4 h-4"
                                            onClick={() =>
                                              handleSpeak(comment.message, idx)
                                            }
                                            onKeyDown={(e) =>
                                              e.key === "Enter" &&
                                              handleSpeak(comment.message, idx)
                                            }
                                            role="button"
                                            tabIndex={0}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="w-[100%] flex gap-0.5 flex-wrap text-xs pl-[10px] leading-[15px] mt-3">
                                      {comment?.message
                                        .split(/\s+/)
                                        .map((word, wordIdx) => (
                                          <span
                                            key={wordIdx}
                                            style={{
                                              backgroundColor:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "yellow"
                                                  : "transparent",
                                              transition:
                                                "background-color 0.2s ease",
                                              marginRight: "4px",
                                              borderRadius:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "4px"
                                                  : "0",
                                              padding:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "0 2px"
                                                  : "0",
                                            }}
                                            aria-live={
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "polite"
                                                : "off"
                                            }
                                          >
                                            {word}
                                          </span>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex justify-start mt-[10px]">
                                  <div className="max-w-[87%] min-w-[30%] text-[#0B0B0B] p-[10px] bg-[#F4F4F4] rounded-[20px]">
                                    <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-[10px]">
                                        <div className="w-[33px] h-[33px] flex justify-center items-center uppercase text-white text-[20px] bg-[#8B8B8B] rounded-full">
                                          {users &&
                                          users[comment?.from].fullName
                                            ? users[comment?.from].fullName[0]
                                            : "U"}
                                        </div>

                                        <div className="text-[15px] font-medium">
                                          {users &&
                                          users[comment?.from]?.fullName
                                            ? users[comment?.from].fullName
                                            : "Unknown"}
                                        </div>

                                        {users &&
                                          !users[comment.from]?.role
                                            ?.toLowerCase()
                                            .includes("hospital") && (
                                            <div className="text-[10px] text-white px-2 py-1 rounded-full bg-[#017C71]">
                                              CC
                                            </div>
                                          )}
                                      </div>

                                      <div>
                                        <div className="flex items-center justify-between px-[10px]">
                                          <div className="text-[10px] text-[#969696]">
                                            {getFormattedDate(
                                              comment.createdAt,
                                            )}
                                          </div>

                                          <div>
                                            <img
                                              src={SpeakerIcon}
                                              alt="speaker-icon"
                                              className="cursor-pointer"
                                              onClick={() =>
                                                handleSpeak(
                                                  comment.message,
                                                  idx,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="w-[100%] flex flex-wrap gap-0.5 text-xs pl-[10px] leading-[15px] mt-3">
                                      {comment?.message
                                        .split(/\s+/)
                                        .map((word, wordIdx) => (
                                          <span
                                            key={wordIdx}
                                            style={{
                                              backgroundColor:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "yellow"
                                                  : "transparent",
                                              transition:
                                                "background-color 0.2s ease",
                                              marginRight: "4px",
                                              borderRadius:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "4px"
                                                  : "0",
                                              padding:
                                                currentCommentId === idx &&
                                                wordIdx === currentWordIndex
                                                  ? "0 2px"
                                                  : "0",
                                            }}
                                            aria-live={
                                              currentCommentId === idx &&
                                              wordIdx === currentWordIndex
                                                ? "polite"
                                                : "off"
                                            }
                                          >
                                            {word}
                                          </span>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div ref={endOfMessagesRef} />
                            </div>
                          );
                        })}
                    </div>
                    {/* INPUT */}
                    {/* <div className="w-full flex justify-center bg-transparent rounded-full flex-shrink-0 pt-2 pb-1">
                      <div
                        style={{
                          border: "1px solid #EAEAEA",
                          boxSizing: "border-box",
                        }}
                        className="w-[98%] mx-auto flex items-center justify-between p-1 rounded-full bg-white"
                      >
                        <textarea
                          placeholder="Type a message..."
                          className="w-[80%] text-[#555] font-semibold outline-none border-none ml-2 resize-none overflow-auto max-h-[300px] bg-transparent"
                          value={message}
                          rows={1}
                          onChange={(e) => setMessage(e.target.value)}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter" &&
                              !e.shiftKey &&
                              message.trim()
                            ) {
                              e.preventDefault();
                              handleCommentAdd();
                            }
                          }}
                        />

                        <div className="flex items-center gap-1">
                          <img
                            src={SpeechToText}
                            alt="speech-to-text-icon"
                            onClick={() => setIsListening(!isListening)}
                          />

                          <img
                            src={SendIcon}
                            alt="send-icon"
                            onClick={handleCommentAdd}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="w-full flex justify-center bg-transparent rounded-full flex-shrink-0 pt-2 pb-1">
                      <div
                        style={{
                          border: "1px solid #EAEAEA",
                          boxSizing: "border-box",
                        }}
                        className="w-[98%] mx-auto flex items-end justify-between p-1 rounded-[24px] bg-white"
                      >
                        <textarea
                          ref={textareaRef}
                          placeholder="Type a message..."
                          className="w-[80%] text-[#555] font-semibold outline-none border-none ml-2 resize-none bg-transparent"
                          style={{
                            lineHeight: `${LINE_HEIGHT}px`,
                            minHeight: `${LINE_HEIGHT * MIN_LINES}px`,
                            maxHeight: `${LINE_HEIGHT * MAX_LINES}px`,
                          }}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter" &&
                              !e.shiftKey &&
                              message.trim()
                            ) {
                              e.preventDefault();
                              handleCommentAdd();
                            }
                          }}
                        />

                        <div className="flex items-center gap-1 mb-1">
                          <img
                            src={SpeechToText}
                            alt="speech-to-text-icon"
                            onClick={() => setIsListening(!isListening)}
                          />
                          <img
                            src={SendIcon}
                            alt="send-icon"
                            onClick={handleCommentAdd}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* CHAT FLOATING ICON */}
            {!queryView && (
              <div className="absolute bottom-1 right-1 z-40">
                <div
                  className="w-[64px] h-[64px] rounded-full   flex justify-center items-center cursor-pointer"
                  onClick={() => setOpenChatBox((prev) => !prev)}
                >
                  <img
                    src={SendIcon}
                    alt="chat-icon"
                    className="w-[34px] h-[34px]"
                  />
                </div>
              </div>
            )}
          </div>
        </Box>
      </Modal>
      {approveRejectionModal && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#017c5780] flex justify-center items-center z-[1210]">
          <div className="relative w-[80%] h-[50%] xl:w-[50%] 2xl:w-[30%] 2xl:h-[30%] flex justify-center items-center bg-white rounded-[16px] p-4">
            <div
              className="absolute top-3 right-3  xl:top-[16px] xl:right-[32px] cursor-pointer"
              onClick={() => {
                setApproveRejectionModal(false);
                setOpen(true);
              }}
            >
              <img src={CrossIcon} alt="close-icon" />
            </div>

            <div>
              <div
                style={{
                  fontFamily: "inherit",
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#797979",
                  marginTop: "16px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <textarea
                  type="text"
                  style={{
                    border: "1px solid #E4E4E4",
                    borderRadius: "8px",
                    height: "100px",
                    padding: "12px",
                  }}
                  className="w-[296px] xl:w-[100%]"
                  placeholder="Rejection reason"
                  onChange={(e) => {
                    setRejectionReason(e.target.value);
                  }}
                />
              </div>
              <p className="text-xl xl:text-2xl font-semibold text-center">
                Are you sure you want to reject.
              </p>
              <div className="flex justify-center items-center gap-2 mt-[10%]">
                <div
                  style={{ border: "1px solid #017C57" }}
                  className="w-[120px] text-xs text-[#017C57] font-semibold text-center  py-2 rounded-full cursor-pointer"
                  onClick={() => {
                    setApproveRejectionModal(false);
                    setOpen(true);
                  }}
                >
                  Go Back
                </div>
                <div
                  style={{ border: "1px solid #017C57" }}
                  className="w-[120px] text-xs text-white bg-[#017C57] font-semibold text-center py-2 rounded-full cursor-pointer"
                  onClick={handleReject}
                >
                  Yes
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {enlargeImage && (
        <div className="fixed h-screen w-screen top-0 left-0 flex justify-center items-center bg-[#017c5780] z-[1206]">
          <div className="relative h-[95%] w-[95%] bg-white p-10 rounded-[20px]">
            <div
              className="absolute top-4 right-8 cursor-pointer"
              onClick={() => {
                setEnlargeImage(null);
                setOpen(true);
              }}
            >
              <img src={CrossIcon} alt="close-icon" />
            </div>

            {/* Image / PDF container */}
            <div className="h-full w-full flex justify-center overflow-auto ">
              <div className="h-full w-full flex justify-center items-center">
                {isPdfDocumentUrl(
                  selectedImg?.documentUrl,
                  selectedImg?.description,
                ) ? (
                  <iframe
                    key={`enlarge-${selectedImg?.documentUrl}`}
                    src={`${selectedImg.documentUrl}#toolbar=1&navpanes=0&scrollbar=1&view=FitH`}
                    title={selectedImg?.description || "document-pdf"}
                    className="rounded-[8px] border-0 bg-white"
                    style={{ width: "100%", height: "100%", minHeight: "80vh" }}
                  />
                ) : (
                  <img
                    src={selectedImg.documentUrl}
                    alt=""
                    className="cursor-zoom-out transition-transform duration-300 object-contain max-h-full max-w-full block"
                    style={{
                      transform: `scale(0.5) rotate(${rotationAngle}deg)`,
                      transformOrigin: "center center",
                    }}
                    onClick={() => {
                      setEnlargeImage(false);
                      setOpen(true);
                    }}
                  />
                )}
              </div>
            </div>

            {/* Left/Right arrows */}
            {/* <div
              className="absolute top-[50%] left-0"
              onClick={handlePrevClick}
            >
              <ArrowBackOutlinedIcon style={{ fontSize: 60 }} />
            </div> */}
            {showArrows && (
              <>
                <div
                  className="absolute top-[50%] left-0"
                  onClick={handlePrevClick}
                >
                  <ArrowBackOutlinedIcon style={{ fontSize: 60 }} />
                </div>

                <div
                  className="absolute top-[50%] right-0"
                  onClick={handleNextClick}
                >
                  <ArrowBackOutlinedIcon
                    style={{ fontSize: 60 }}
                    className="rotate-180"
                  />
                </div>
              </>
            )}
            <div
              className="absolute top-[50%] right-0"
              onClick={handleNextClick}
            >
              <ArrowBackOutlinedIcon
                style={{ fontSize: 60 }}
                className=" rotate-180"
              />
            </div>

            {/* Bottom controls */}
            <div
              style={{ border: "1px solid #d5d5d5" }}
              className="absolute bottom-1 left-3 w-[50%] flex gap-4 justify-center items-center  p-4 mt-1 rounded-[8px] "
            >
              {/* Ready for submission */}
              <div
                className="flex items-center gap-1 cursor-pointer "
                onClick={() => handleReadyToSubmissionCheck(docDetails?.id)}
              >
                {readyForRpaSubmission ? (
                  <CircularProgress />
                ) : (
                  <>
                    <input
                      type="checkbox"
                      checked={
                        docDetails?.documenturlmasters &&
                        docDetails?.documenturlmasters[selectedImg.idx]?.status
                          ?.toLowerCase()
                          ?.includes("readyforrpa")
                      }
                      className="h-[20px] w-[20px]"
                    />
                    <div className="text-nowrap">Ready to Submission</div>
                  </>
                )}
              </div>

              {/* Reject button */}
              {isSubmitting ? (
                <div>
                  <CircularProgress />{" "}
                </div>
              ) : (
                type === "review" &&
                caseDetails?.isTpa !== true && (
                  <div>
                    <button
                      style={{
                        borderRadius: "32px",
                        fontFamily: "Inter, sans-serif",
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "12px",
                        backgroundColor: "#FF4343",
                        color: "white",
                        border: "1px solid #FF4343",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      className="h-[34px] w-[120px] xl:w-[160px] "
                      onClick={() => {
                        setApproveRejectionModal(true);
                        setOpen(false);
                      }}
                    >
                      <CancelOutlinedIcon sx={{ height: "18px" }} /> REJECT
                    </button>
                  </div>
                )
              )}

              {/* Download button */}
              <div
                style={{ border: "1px solid #E4E4E4" }}
                className="flex justify-center items-center bg-white rounded-full p-2"
              >
                <a
                  href={selectedImg.documentUrl}
                  download
                  target="_blank"
                  className="flex gap-1 items-center no-underline"
                >
                  <FileDownloadOutlinedIcon
                    className="text-[#017C57]"
                    sx={{ fontSize: "18px" }}
                  />{" "}
                  <div
                    style={{ display: width > 1780 ? "block" : "none" }}
                    className=" text-[#017c57] text-sm fonr-semibold"
                  >
                    Download
                  </div>
                </a>
              </div>

              {/* 🔄 Rotate button */}
              <div
                style={{ border: "1px solid #E4E4E4" }}
                className="flex justify-center items-center bg-white rounded-full p-2 cursor-pointer"
                onClick={handleRotate}
              >
                <RotateRightOutlinedIcon
                  className="text-[#017C57]"
                  sx={{ fontSize: "20px" }}
                />
                <div
                  style={{ display: width > 1780 ? "block" : "none" }}
                  className=" text-[#017c57] text-sm font-semibold ml-1"
                >
                  Rotate
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {editImage && (
        <EditImageFeature
          selectedImg={selectedImg}
          setOpen={setEditImage}
          documentDetails={documentDetails}
        />
      )}
      {openMultipleDownloads && (
        <DownloadMultipleDocuments
          setOpen={setOpenMultipleDownloads}
          images={documentDetails?.documenturlmasters}
          documentName={documentDetails?.documentName}
          tmsVersion={tmsVersion}
        />
      )}
      {showProcedurePopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#00000040] flex justify-center items-center z-[1300]">
          <div className="bg-[#F3F3F3] w-[95%] xl:w-[70%] 2xl:w-[55%] rounded-[40px] py-10 px-8 text-center">
            {" "}
            <div className="text-[20px] xl:text-[28px] font-medium text-[#191919] mb-10 whitespace-nowrap">
              Are you sure, you want to change the existing Procedure ?
            </div>
            <div className="flex justify-center gap-6">
              {/* YES BUTTON */}
              <div
                onClick={handleConfirmProcedureChange}
                className="bg-[#0E7C57] text-white px-10 py-4 rounded-full cursor-pointer text-[16px] font-medium"
              >
                Yes, Change Procedure
              </div>

              {/* CANCEL BUTTON */}
              <div
                onClick={handleCancelProcedureChange}
                className="border border-solid border-[#FF6B6B] text-[#FF6B6B] px-10 py-4 rounded-full cursor-pointer text-[16px] font-medium"
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      )}
      {showDoctorPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-[#00000040] flex justify-center items-center z-[1300]">
          <div className="bg-[#F3F3F3] w-[90%] xl:w-[60%] 2xl:w-[50%] rounded-[40px] py-10 px-8 text-center">
            <div className="text-[24px] xl:text-[24px] font-medium text-[#191919] mb-10">
              Are you sure, you want to change the existing Doctor ?
            </div>

            <div className="flex justify-center gap-6">
              <div
                onClick={handleConfirmDoctorChange}
                className="bg-[#0E7C57] text-white px-10 py-4 rounded-full cursor-pointer text-[16px] font-medium"
              >
                Yes, Change Doctor
              </div>

              <div
                onClick={handleCancelDoctorChange}
                className="border border-solid border-[#FF6B6B] text-[#FF6B6B] px-10 py-4 rounded-full cursor-pointer text-[16px] font-medium"
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
